import './PopupMentalMatrix.scss';

export const PopupMentalMatrix = (props) => {
    return <div className="c-detail-fiche__body">
        <div className="practical">
            <div className="left">
                <div className="inner">
                    <div className="bottom">
                        <PopupMentalMatrixSideBar dictionary={props.dictionary} data={props.data}
                        />
                    </div>
                </div>
            </div>
            <div className="right">
                <PopupMentalMatrixBody dictionary={props.dictionary} blockListBodyContentHandler={props.blockListBodyContentHandler} data={props.data} />
            </div>
        </div>
    </div>;
}


const PopupMentalMatrixSideBar = (props) => {
    return props.data.detailSideBar &&
        <div className="bottom">
            {
                props.data.detailSideBar.subject &&

                <div className="info">
                    <p className="title">
                        {props.dictionary.subject}
                    </p>
                    <p>
                        {props.data.detailSideBar.subject}
                    </p>
                </div>
            }
            {
                props.data.detailSideBar.age &&
                <div className="info">
                    <p className="title">
                        {props.dictionary.age}
                    </p>
                    <p>
                        {props.data.detailSideBar.age}
                    </p>
                </div>
            }
            {
                props.data.detailSideBar.subTheme &&
                <div className="info">
                    <p className="title">
                        {props.dictionary.supervisors}
                    </p>
                    <p>
                        {props.data.detailSideBar.supervisors}
                    </p>
                </div>
            }
            {
                props.data.detailSideBar.lenthOfTime &&
                <div className="info">
                    <p className="title">
                        {props.dictionary.lengthOfTime}
                    </p>
                    <p>
                        {props.data.detailSideBar.lenthOfTime}
                    </p>
                </div>
            }
            {
                props.data.detailSideBar.material &&
                <div className="info">
                    <p className="title">
                        {props.dictionary.material}
                    </p>
                    <p>
                        {props.data.detailSideBar.material}
                    </p>
                </div>
            }
        </div>;
}

const PopupMentalMatrixBody = (props) => {

    return <div className="inner">
        {
            props.data.detailBody.goal && <div className='c-content-block text-block'>
                <h3>
                    {props.dictionary.goal}
                </h3>
                <div dangerouslySetInnerHTML={{ __html: props.data.detailBody.goal }}>
                </div>
            </div>
        }
        {
            props.data.detailBody.instructions && <div className='c-content-block text-block'>
                <h3>
                    {props.dictionary.instructions}
                </h3>
                <div dangerouslySetInnerHTML={{ __html: props.data.detailBody.instructions }}>
                </div>
            </div>
        }
        {
            props.data.detailBody.finalDiscussion && <div className='c-content-block text-block'>
                <h3>
                    {props.dictionary.finalDiscussion}
                </h3>
                <div dangerouslySetInnerHTML={{ __html: props.data.detailBody.finalDiscussion }}>
                </div>
            </div>
        }
        {
            props.data.detailBody.alternative && <div className='c-content-block text-block'>
                <h3>
                    {props.dictionary.alternative}
                </h3>
                <div dangerouslySetInnerHTML={{ __html: props.data.detailBody.alternative }}>
                </div>
            </div>
        }
    </div>;

}
